import { normalizeInputDigits } from './localizedInput';

export type CustomZoneEntryMode = 'absolute' | 'percent';

/** Custom HR/power endpoints store integer absolute bounds. No API change. */
export function customZoneBounds(minimum: string, maximum: string, mode: CustomZoneEntryMode, threshold?: string): { minimum: number; maximum: number } | null {
  const parse = (text: string) => text.trim() === '' ? NaN : Number(normalizeInputDigits(text).replace('٫', '.'));
  let low = parse(minimum), high = parse(maximum);
  if (!Number.isFinite(low) || !Number.isFinite(high) || low < 0 || low >= high) return null;
  if (mode === 'percent') {
    const base = parse(threshold ?? '');
    if (!Number.isFinite(base) || !Number.isInteger(base) || base <= 0) return null;
    low = Math.trunc(base * low / 100);
    high = Math.trunc(base * high / 100);
  }
  return Number.isFinite(low) && Number.isFinite(high) && Number.isInteger(low) && Number.isInteger(high) && low < high ? { minimum: low, maximum: high } : null;
}
